import * as ActionTypes from './ActionTypes';
import { baseUrl } from '../shared/baseUrl';

//this function updates the local state of the app
export const addComment = (comment) => ({
    type: ActionTypes.ADD_COMMENT,
    payload: comment
});

//this function updates the comments in the server
export const postComment = (dishId, rating, author, comment) => (dispatch) => {
    const newComment = {
        dishId: dishId,
        rating: rating,
        author: author,
        comment: comment
    }

    newComment.date = new Date().toISOString();

    return fetch(baseUrl + 'comments', {
        method: "POST",
        body: JSON.stringify(newComment),
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                //case when server is reached but server does not respond with a 200
                let err = new Error(`Error ${response.status}: ${response.statusText}`);
                throw err;
            }
        }, (errConnection) => {
            //case when server can't be reached
            let err = new Error(errConnection.message);
            throw err;
        })
        .then(comment => dispatch(addComment(comment)))
        .catch(err => {
            console.log("POST Comments Failed:", err.message);
            alert(`You comment could not be posted!\n", ${err.message}`);
        });
}

export const postFeedback = (values) => (dispatch) => {
    const newFeedBack = values;

    return fetch(baseUrl + 'feedback', {
        method: "POST",
        body: JSON.stringify(newFeedBack),
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                //case when server is reached but server does not respond with a 200
                let err = new Error(`Error ${response.status}: ${response.statusText}`);
                throw err;
            }
        }, (errConnection) => {
            //case when server can't be reached
            let err = new Error(errConnection.message);
            throw err;
        })
        .then(feedback => {
            console.log("Feedback", JSON.stringify(feedback));
            alert(`Thank you for your Feedback!`); //\n ${JSON.stringify(feedback)}
        })
        .catch(err => {
            console.log("POST Feedback Failed:", err.message);
            alert(`Sorry, your feedback could not be posted!`); //\n, ${err.message}
        });
}

export const fetchDishes = () => (dispatch) => {
    dispatch(dishesLoading());

    return fetch(baseUrl + 'dishes')
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                //case when server is reached but server does not respond with a 200
                let err = new Error(`Error ${response.status}: ${response.statusText}`);
                throw err;
            }
        }, (errConnection) => {
            //case when server can't be reached
            let err = new Error(errConnection.message);
            throw err;
        })
        .then(dishes => dispatch(addDishes(dishes)))
        .catch(err => dispatch(dishesFailed(err.message)));
}

export const fetchComments = () => (dispatch) => {
    return fetch(baseUrl + 'comments')
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                //case when server is reached but server does not respond with a 200
                let err = new Error(`Error ${response.status}: ${response.statusText}`);
                throw err;
            }
        }, (errConnection) => {
            //case when server can't be reached
            let err = new Error(errConnection.message);
            throw err;
        })
        .then(comments => dispatch(addComments(comments)))
        .catch(err => dispatch(commentsFailed(err.message)));
}

export const fetchPromos = () => (dispatch) => {
    dispatch(promosLoading());

    return fetch(baseUrl + 'promotions')
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                //case when server is reached but server does not respond with a 200
                let err = new Error(`Error ${response.status}: ${response.statusText}`);
                throw err;
            }
        }, (errConnection) => {
            //case when server can't be reached
            let err = new Error(errConnection.message);
            throw err;
        })
        .then(promos => dispatch(addPromos(promos)))
        .catch(err => dispatch(promosFailed(err.message)));
}

export const fetchLeaders = () => (dispatch) => {
    dispatch(leadersLoading());

    return fetch(baseUrl + 'leaders')
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                //case when server is reached but server does not respond with a 200
                let err = new Error(`Error ${response.status}: ${response.statusText}`);
                throw err;
            }
        }, (errConnection) => {
            //case when server can't be reached
            let err = new Error(errConnection.message);
            throw err;
        })
        .then(leaders => dispatch(addLeaders(leaders)))
        .catch(err => dispatch(leadersFailed(err.message)));
}

//return an action with only action type and no payload
export const dishesLoading = () => ({
    type: ActionTypes.DISHES_LOADING
});

export const dishesFailed = (errMessage) => ({
    type: ActionTypes.DISHES_FAILED,
    payload: errMessage
});

export const addDishes = (dishes) => ({
    type: ActionTypes.ADD_DISHES,
    payload: dishes
});

export const commentsFailed = (errMessage) => ({
    type: ActionTypes.COMMENTS_FAILED,
    payload: errMessage
});

export const addComments = (comments) => ({
    type: ActionTypes.ADD_COMMENTS,
    payload: comments
});

export const promosLoading = () => ({
    type: ActionTypes.PROMOS_LOADING
});

export const promosFailed = (errMessage) => ({
    type: ActionTypes.PROMOS_FAILED,
    payload: errMessage
});

export const addPromos = (promos) => ({
    type: ActionTypes.ADD_PROMOS,
    payload: promos
});

export const leadersLoading = () => ({
    type: ActionTypes.LEADERS_LOADING
});

export const leadersFailed = (errMessage) => ({
    type: ActionTypes.LEADERS_FAILED,
    payload: errMessage
});

export const addLeaders = (leaders) => ({
    type: ActionTypes.ADD_LEADERS,
    payload: leaders
});